import React from "react";

// Clear All moved into the footer (see FooterAction) now that filters auto-apply.
const HeaderAction = () => {
  return (
    <div className="filterHeader">
      <span className="name">Filter</span>
    </div>
  );
};

export default HeaderAction;
